import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../../../../services/data.service';
import { IceapiService } from '../../../../services/index';
import { CalculationType } from '../../enums/calculation-type.enum';
import { CalculationResult, InputGroup, ToolOutput } from '../../models/calculationModels/index';
import { ClampInputData, DiagramDataModel, DiagramInfo, SubHeaderData, TighteningData } from '../../models/index';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-clamp',
    templateUrl: './clamp.component.html',
    styleUrls: ['./clamp.component.scss'],
    standalone: false
})
export class ClampComponent implements OnInit {
    @Input() cssClass: '';
    @ViewChild('panel1') panel1;
    @ViewChild('panel2') panel2;
    @ViewChild('panel4') panel4;
    @ViewChild('beginbtn', { static: false }) beginbtn: ElementRef;
    destroy$ = new Subject();

    subHeaderData: SubHeaderData;
    clampInput: InputGroup;
    calculationResult: CalculationResult;
    diagramInfo: DiagramDataModel;
    isInitialFormLoad: boolean = true;
    tooltip_position = 'above';
    tighteningform = false;
    stdInputform = false;
    toolsform = false;
    showpaneltoggle = false;
    showPanelUnitToggle = false;
    editpanel_1 = false;
    editpanel_2 = false;
    editpanel_4 = false;
    isRedirect: string = 'false';
    outputTabIndex = 0;
    selectedTool: ToolOutput;
    instanceId: string;
    isTighteningInputValid: boolean = false;
    isInputValid: boolean = false;
    toolsData: ToolOutput[];
    clampInputFormGroup: UntypedFormGroup;
    tighteningProcedureForm: UntypedFormGroup;
    toolsFormGroup: UntypedFormGroup;
    LoadCalculationSubscription: Subscription;
    hideTab: boolean = false;
    IsCalculationOutPutTabSelected: boolean = false;
    isCalculationDone: boolean;
    isTighFormValid: boolean = false;
    isClampFormValid: boolean = false;

    constructor(
        private iceapi: IceapiService,
        private renderer: Renderer2,
        private route: ActivatedRoute,
        private dataSvc: DataService,
        private router: Router,
        private cd: ChangeDetectorRef,
        private ngxUiLoaderService: NgxUiLoaderService,
        private globalEmittersService: GlobalEmittersService,
        private user_utility: UserUtilityService,
         private translocoService: TranslocoService
    ) {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    }

    ngOnInit() {
        this.subHeaderData = this.setSubHeaderValues();
        this.clampInput = new InputGroup();
        this.diagramInfo = new DiagramDataModel();

        this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
            this.isRedirect = params['isRedirect'];
        });
        if (this.isRedirect == 'true') {
            this.ngxUiLoaderService.start();
            this.calculationResult = this.dataSvc?.calculationData;
            this.clampInput = this.dataSvc?.calculationData?.input;
            this.toolsData = this.dataSvc?.calculationData?.output?.tools;
            this.isInitialFormLoad = false;
            this.editpanel_1 = true;
            this.editpanel_2 = true;
            this.editpanel_4 = true;
            this.tighteningform = true;
            this.stdInputform = true;
            this.toolsform = true;
            this.globalEmittersService.isCalculationHappen.next(true);
            this.isCalculationDone = true;
            this.ngxUiLoaderService.stop();
        } else {
            this.globalEmittersService.isCalculationHappen.next(false);
            this.clampInput = new InputGroup();
            this.dataSvc.calculationData = null;
        }

        this.globalEmittersService.currentCalculationType.next(CalculationType.Clamp);

        this.globalEmittersService.clampInputFormGroup.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.clampInputFormGroup = res;
            res?.valueChanges?.pipe(takeUntil(this.destroy$)).subscribe((val) => {
                if (val && this.isCalculationDone) {
                    this.isClampFormValid = false;
                }
            });
        });

        this.globalEmittersService.tighteningProcedureForm.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.tighteningProcedureForm = res;
            res?.valueChanges?.pipe(takeUntil(this.destroy$)).subscribe((val) => {
                if (val && this.isCalculationDone) {
                    this.isTighFormValid = false;
                }
            });
        });

        this.globalEmittersService.toolsFormGroup.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.toolsFormGroup = res;
        });

        this.LoadCalculationSubscription = this.globalEmittersService.LoadCalculation.pipe(takeUntil(this.destroy$)).subscribe((data: boolean) => {
            if (data) {
                this.btnCalculateClicked();
                if (this.selectedTool) {
                    this.globalEmittersService.ManufactureName.next(this.selectedTool.manufacturer.name);
                    this.globalEmittersService.ToolSelectedId.next(this.selectedTool.id);
                    this.IsCalculationOutPutTabSelected = true;
                }
            }
        });

        this.globalEmittersService.isCalculationHappen.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) {
                this.hideAdvanceOption();
            }
        });
    }

    hideAdvanceOption(): void {
        if (this.calculationResult?.output) {
            this.hideTab = true;
        }
        if (this.calculationResult?.output?.general?.warnings) {
            let res = this.calculationResult.output.general.warnings.some((w) => w.severity <= 1);
            if (res === true) {
                this.hideTab = false;
            }
        }
    }

    setSubHeaderValues(): SubHeaderData {
        let headerData = new SubHeaderData();
        headerData.displayText = this.translocoService.translate('HOME_PAGE.HEADER.INFORMATE_DROPDOWN.LINK.CLAMP');
        headerData.disableActions = true;
        headerData.defaultImageSrc = '../../../../../../assets/media/logos/clamp-black-button.png';
        headerData.mouseOverImageSrc = '../../../../../../assets/media/logos/clamp-yellowbutton.png';
        return headerData;
    }

    //Tightening Procedure
    tighteningDataHandler(tighteningData: TighteningData) {
        if (tighteningData.isDataValid) {
            this.clampInput.others.tighteningMethod = tighteningData.tighteningMethod;
            this.clampInput.others.breakout = tighteningData.breakout;
            this.clampInput.others.percentageCover = tighteningData.percentageCover;
            this.clampInput.others.lubricantMode = tighteningData.lubricantMode;
            this.clampInput.recordId.lubricantId = tighteningData.lubricantId;
            this.clampInput.calculationOverrides.kFactor = tighteningData.kFactor;
            this.isTighteningInputValid = true;
            this.isTighFormValid = true;
        } else {
            this.isTighteningInputValid = false;
        }
        if (!this.editpanel_1) {
            this.panel2.open();
        }

        this.editpanel_1 = true;
        this.tighteningform = false;
        this.panel1.close();
        this.setValidity();
    }

    InputsDataHandler(clampInputData: ClampInputData) {
        if (clampInputData.isDataValid) {
            this.clampInput.recordId.manufacturerId = clampInputData.manufacturerId;
            this.clampInput.recordId.boltMaterialId = clampInputData.boltMaterialId;
            this.clampInput.recordId.clampId = clampInputData.clampId;
            this.clampInput.recordId.clampMaterialId = clampInputData.clampMaterialId;
            this.clampInput.recordId.hubMaterialId = clampInputData.hubMaterialId;
            this.clampInput.recordId.pipeScheduleId = clampInputData.pipeScheduleId;
            this.clampInput.recordId.pipeSizeId = clampInputData.pipeSizeId;
            this.clampInput.recordId.sealRingMaterialId = clampInputData.sealRingMaterialId;
            this.clampInput.recordId.sealRingId = clampInputData.sealRingId;
            //this.clampInput.recordId.boltDimensionId = clampInputData.boltDimensionId     ??
            //this.clampInput.recordId.nutDimensionId = clampInputData.nutDimensionId       ??

            //adding misalignmentFactor
            this.clampInput.others.misalignmentFactor = clampInputData.misalignmentFactor;
            this.clampInput.others.boltType = clampInputData.boltType;
            this.clampInput.others.washerThickness = clampInputData.washerThickness;

            this.isInputValid = true;
            this.isClampFormValid = true;
        } else {
            this.isInputValid = false;
        }

        if (!this.editpanel_2) {
            this.panel4.open();
        }

        this.editpanel_2 = true;
        this.stdInputform = false;
        this.panel2.close();
        this.setValidity();
    }

    toolsDataHandler(nearestObstruction: string) {
        this.clampInput.calculationOverrides.distanceToNearestObstruction = nearestObstruction;
    }

    selectedToolDataHandler(selectedToolId: string) {
        this.calculationResult.output.tools.forEach((x) => (x.isSelected = false));
        this.calculationResult.output.tools.find((x) => x.id === selectedToolId).isSelected = true;
        this.selectedTool = this.calculationResult.output.tools.find((x) => x.id === selectedToolId);
        this.dataSvc.selectedToolId = selectedToolId;
        this.outputTabIndex = 1;
    }

    async invokeCalculate(inputGroup: InputGroup) {
        this.tighteningform = false;
        this.stdInputform = false;
        await this.iceapi
            .postCalculateClamp(inputGroup)
            .toPromise()
            .then((res) => {
                if (res.success === true) {
                    if (res.response.calculationSucceeded) {
                        if (!this.editpanel_2) {
                            this.panel2.open();
                        }
                        this.editpanel_2 = true;
                        this.calculationResult = res.response;
                        this.globalEmittersService.isCalculationHappen.next(true); // * this is used for tools component to display conditional based warning
                        this.toolsData = this.calculationResult.output.tools;
                        if (!this.toolsData.length) {
                            this.outputTabIndex = 1;
                        }
                        this.subHeaderData.disableActions = false;
                        this.outputTabIndex = 0;
                        this.cd.markForCheck();
                        this.panel4.open();
                        if (this.IsCalculationOutPutTabSelected) {
                            this.outputTabIndex = 1;
                        }
                        this.isCalculationDone = true;
                    } else {
                        this.globalEmittersService.isCalculationHappen.next(false);
                    }
                } else {
                    this.globalEmittersService.isCalculationHappen.next(false);
                    this.user_utility.errorModelPopup(res.message);
                }
            })
            .catch(() => {
                this.ngxUiLoaderService.stop();
            });
    }

    diagramDataHandler(diagramInfo: DiagramInfo) {
        switch (diagramInfo.diagramType) {
            case 'Clamp':
                if (diagramInfo.diagramId || diagramInfo.pipesizeId) {
                    this.diagramInfo.clamp = diagramInfo;
                    this.diagramInfo.isDiagramsAdded = true;
                } else {
                    this.diagramInfo.isDiagramsAdded = false;
                    this.diagramInfo.clamp = null;
                }
                break;
            case 'Tool Image':
                this.diagramInfo.toolImage = diagramInfo;
                break;
            case 'Tool Diagram':
                this.diagramInfo.tool = diagramInfo;
                break;
        }
    }

    btnCalculateClicked() {
        this.globalEmittersService.refreshWarnings.next(true);
        if (this.isInputValid || this.isRedirect == 'true') {
            this.ngxUiLoaderService.start();
            this.clampInput.calculationType = CalculationType.Clamp;
            if (!this.clampInput.calculationOverrides.distanceToNearestObstruction) {
                this.clampInput.calculationOverrides.distanceToNearestObstruction = '1000 mm';
            }
            this.invokeCalculate(this.clampInput)
                .then(() => {
                    this.ngxUiLoaderService.stop();
                    this.iceapi.calculationRes.next(true);
                    this.globalEmittersService.refreshTools.next(true);
                })
                .catch(() => {
                    this.ngxUiLoaderService.stop();
                });
        }
    }

    setValidity() {
        if (this.isTighteningInputValid && this.isInputValid) {
            this.isInputValid = true;
        } else {
            this.isInputValid = false;
        }
    }

    beginform() {
        this.isInitialFormLoad = false;
        this.tighteningform = true;
        this.stdInputform = false;
        this.toolsform = false;
        this.renderer.addClass(this.beginbtn.nativeElement, 'active');
    }

    showPanel1() {
        if (this.editpanel_1 == true) this.tighteningform = true;
        this.stdInputform = false;
        this.toolsform = false;
    }

    showPanel2() {
        if (this.tighteningProcedureForm.valid) {
            this.tighteningform = false;
            this.stdInputform = true;
            this.toolsform = false;
        }
    }

    showPanel4() {
        if (this.clampInputFormGroup.valid) {
            this.tighteningform = false;
            this.stdInputform = false;
            this.toolsform = true;
        }
    }

    showpanel() {
        this.showpaneltoggle = !this.showpaneltoggle;
    }

    hidepanelclose() {
        this.showpaneltoggle = false;
    }

    showUnitpanel() {
        this.showPanelUnitToggle = !this.showPanelUnitToggle;
    }

    hideUnitpanelClose() {
        this.showPanelUnitToggle = false;
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
